<template>
    <div class="page-wrapper">
        <h2>Метрики за день</h2>
        <h-table
            :data="data"
            row-key="name"
            :columns="metricsColumns"
            :loading="metricsLoading"
            :pagination.sync="serverPagination"
            :rows-per-page-options='perPageOptions'
            ref="table"
            @request="fetchMetrics"
        >
            <q-tr slot="header" slot-scope="props" ref="thead">
                <h-th v-for="(col, index) in props.cols" :key="col.name" :props="props"
                      :class="{'loading': metricsLoading}">
                    {{ col.label }}
                </h-th>
            </q-tr>
        </h-table>
    </div>

</template>

<script>
import { BarChart, HTable, HTh } from 'components'
import { date, QTr } from 'quasar'
import tableHelpers from '@/HTable/helpers'
import api from 'mixins/api'

export default {
    name: 'ProjectDailyMetricsView',

    components: {
        HTable,
        HTh,
        BarChart,
        QTr,
    },

    mixins: [
        tableHelpers,
        api,
    ],

    data () {
        return {
            metricsColumns: [
                {
                    label: 'Дата',
                    field: 'created_at',
                    name: 'created_at',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    type: 'text',
                    format: createdAt => {
                        return date.formatDate(createdAt, 'YYYY-MM-DD')
                    },
                },
                {
                    label: 'Заказы',
                    field: 'orders_count',
                    name: 'orders_count',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    type: 'text',
                },
                {
                    label: 'Товары',
                    field: 'products_count',
                    name: 'products_count',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    type: 'text',
                },
            ],
            metricsLoading: false,
        }
    },

    mounted () {
        this.fetchMetrics({
            pagination: this.serverPagination,
            filter: this.filter,
        })
    },

    methods: {
        fetchMetrics ({ pagination, filter }) {
            this.metricsLoading = true

            this.query = this.getQuery(pagination, filter)
            this.api.get(`projects/${this.$route.params.id}/metrics/daily${this.query}`).then(response => {
                this.updatePagination(pagination, response.data.total)
                this.updateData(response.data.data)

                this.metricsLoading = false
            }).catch(error => {
                console.error(error)
                this.$q.notify({
                    message: 'Не удалось загрузить метрики',
                })
                this.metricsLoading = false
            })
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectDailyMetricsView.vue